import React from 'react'
import { ArchitectIcon } from './ArchitectIcon'
import { SageIcon } from './SageIcon'

export interface PersonalityIconProps {
  personalityId: string
  width?: string | number
  height?: string | number
  className?: string
  useGradient?: boolean
}

export const PersonalityIcon: React.FC<PersonalityIconProps> = ({
  personalityId,
  ...props
}) => {
  switch (personalityId) {
    case '2': // Sage personality ID
      return <SageIcon {...props} />
    case '1': // Architect personality ID (or other IDs)
    default:
      return <ArchitectIcon {...props} />
  }
}
